import api from '../../utils/api'

import { useState } from 'react'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormProcedure from './Form/FormProcedure'

function NewProcedure({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    async function registerProcedure(procedure) {
        let msgType = 'success'

        const data = await api.post('/procedure/new', procedure, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {
            handleOnSuccess()
        }
    }

    return (
        <section>
            <FormProcedure
                title="Novo Procedimento"
                handleSubmit={registerProcedure}
                btCancelAction={btCancelAction}
            />
        </section>
    )
}

export default NewProcedure
